module.exports = __webpack_public_path__ + "img/大觉寺.c6656a07.png";